/* Live Free — the Ingredient Index (BUILD-07 §1). Built to `Ingredient Index.dc.html`.
   No dependencies. Everything below the tool head is progressive: the page ships
   the first sixty entries as plain links, and this script takes over once the
   JSON feed (?view=lf-glossary-data) has been fetched — on first interaction,
   or on idle after load when the section says so and the connection is not
   metered. Verdict keys are the six on the lf_ingredient definition. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lf-glossary]');
  if (!root) return;

  var ORDER = ['never-allowed', 'safe-comedogenic', 'depends-on-dose', 'allowed', 'cleaner-choice', 'we-look-for-this'];
  var POSITIVE = { 'we-look-for-this': 1, 'cleaner-choice': 1 };
  var VERD = readJSON('[data-lf-verdicts]') || {};
  var T = readJSON('[data-lf-i18n]') || {};
  var CAP = Math.max(50, parseInt(root.getAttribute('data-lf-cap'), 10) || 400);
  var SORT = root.getAttribute('data-lf-sort') || 'verdict';
  var FEED = root.getAttribute('data-lf-feed');
  var ASSET = root.getAttribute('data-lf-asset') || '';
  var TOTAL = parseInt(root.getAttribute('data-lf-total'), 10) || 0;
  var EXAMPLE = root.getAttribute('data-lf-example') || '';
  var AGES = String(T.ages || '').split('|').map(trim).filter(Boolean);
  var MORE = [
    ['avoid', function (it) { return !!it.pr; }],
    ['nonco', function (it) { return !it.pr && it.v !== 'never-allowed'; }],
    ['catalog', function (it) { return it.p.length > 0; }],
    ['written', function (it) { return it.d === 'written'; }]
  ];

  var el = {
    tabs: root.querySelectorAll('[data-lf-tab]'),
    panels: root.querySelectorAll('[data-lf-panel]'),
    q: root.querySelector('[data-lf-q]'),
    count: root.querySelector('[data-lf-count]'),
    clear: root.querySelector('[data-lf-clear]'),
    facets: root.querySelector('[data-lf-facets]'),
    groups: root.querySelector('[data-lf-facet-groups]'),
    status: root.querySelector('[data-lf-status]'),
    list: root.querySelector('[data-lf-list]'),
    capped: root.querySelector('[data-lf-capped]'),
    label: root.querySelector('[data-lf-label]'),
    labelClear: root.querySelector('[data-lf-label-clear]'),
    labelReset: root.querySelector('[data-lf-label-reset]'),
    vbox: root.querySelector('[data-lf-vbox]'),
    vhead: root.querySelector('[data-lf-vhead]'),
    vsub: root.querySelector('[data-lf-vsub]'),
    crows: root.querySelector('[data-lf-crows]'),
    cempty: root.querySelector('[data-lf-cempty]'),
    cunmatched: root.querySelector('[data-lf-cunmatched]')
  };

  var S = {
    data: null, loading: null, error: null,
    mode: 'browse', q: '', open: null,
    sel: { verdict: [], function: [], good: [], skin: [], age: [], more: [] }
  };

  /* ---------- helpers ---------- */
  function readJSON(sel) { var n = root.querySelector(sel); try { return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; } }
  function trim(s) { return String(s).trim(); }
  function h(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function fmt(s, map) { return String(s || '').replace(/\[(\w+)\]/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
  function num(n) { return Number(n).toLocaleString('en-US'); }
  function handle(n) { return String(n).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function norm(n) { return String(n).toLowerCase().replace(/\([^)]*\)/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function isAny(v) { return /^any\b/i.test(v); }
  function chip(key, size) { var c = h('span', 'lf-chip lf-chip--' + key + ' lf-chip--' + (size || 'md'), VERD[key] || key); return c; }
  function badge(label, tone) { return h('span', 'lf-gbadge' + (tone ? ' lf-gbadge--' + tone : ''), label); }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); var a = arguments, c = this; t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  /* ---------- data ---------- */
  function load() {
    if (S.data) return Promise.resolve();
    if (S.loading) return S.loading;
    setStatus(fmt(T.loading, { t: num(TOTAL) }), '');
    S.loading = fetchPage(1).then(function (first) {
      /* The storefront feed is live from admin but Shopify's metaobject paginate caps at 1000
         and ignores ?page=. The theme asset (written by the import) supplies whatever the feed
         could not reach; a live entry always wins over its asset copy. */
      var need = (first.meta.total || 0) > first.items.length;
      var tail = need && ASSET ? fetch(ASSET, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { items: [] }; }).catch(function () { return { items: [] }; }) : Promise.resolve({ items: [] });
      return tail.then(function (extra) {
        var items = first.items.slice(), seen = {};
        items.forEach(function (it) { seen[it.h || handle(it.n)] = 1; });
        (extra.items || []).forEach(function (it) { if (!seen[it.h]) items.push(it); });
        items.forEach(prep);
        S.data = items;
        S.loading = null;
        setStatus('', '');
        onData();
      });
    }).catch(function () {
      S.loading = null;
      setStatus(T.error, 'error');
    });
    return S.loading;
  }
  function fetchPage(p) {
    return fetch(FEED + '&page=' + p, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (txt) { return JSON.parse(txt); });
  }
  function prep(it) {
    it.a = it.a || []; it.f = it.f || []; it.g = it.g || []; it.s = it.s || []; it.b = it.b || []; it.p = it.p || []; it.src = it.src || [];
    it._h = it.h || handle(it.n);
    it._blob = (it.n + ' ' + it.a.join(' ') + ' ' + (it.w || '')).toLowerCase();
    it._norms = [norm(it.n)].concat(it.a.map(norm));
  }
  function onData() {
    var pager = el.list.querySelector('[data-lf-pager]');
    if (pager) pager.remove();
    el.facets.hidden = false;
    var entry = new URLSearchParams(location.search).get('entry');
    if (entry) { var hit = S.data.filter(function (x) { return x._h === entry; })[0]; if (hit) { S.open = hit._h; if (!S.q) { S.q = hit.n; el.q.value = hit.n; } } }
    renderBrowse();
    renderCheck();
  }
  function setStatus(text, kind) {
    el.status.textContent = text || '';
    el.status.className = 'lf-gstatus' + (kind ? ' lf-gstatus--' + kind : '');
    el.status.hidden = !text;
  }

  /* ---------- filtering ---------- */
  function pass(it, sel, q, skip) {
    if (q && it._blob.indexOf(q) === -1) return false;
    if (skip !== 'verdict' && sel.verdict.length && sel.verdict.indexOf(it.v) === -1) return false;
    if (skip !== 'function' && sel.function.length && !sel.function.some(function (v) { return it.f.indexOf(v) > -1; })) return false;
    if (skip !== 'good' && sel.good.length && !sel.good.some(function (v) { return it.g.indexOf(v) > -1; })) return false;
    if (skip !== 'skin' && sel.skin.length && !sel.skin.some(function (v) { return it.s.indexOf(v) > -1 || it.s.some(isAny); })) return false;
    if (skip !== 'age' && sel.age.length && !sel.age.some(function (v) { return it.b.indexOf(v) > -1; })) return false;
    if (skip !== 'more' && sel.more.length) {
      for (var i = 0; i < sel.more.length; i++) { var m = MORE.filter(function (x) { return x[0] === sel.more[i]; })[0]; if (m && !m[1](it)) return false; }
    }
    return true;
  }
  function anyFilter() { return !!(S.q || Object.keys(S.sel).some(function (k) { return S.sel[k].length; })); }
  function toggle(group, val) {
    var cur = S.sel[group], i = cur.indexOf(val);
    if (i > -1) cur.splice(i, 1); else cur.push(val);
    renderBrowse();
  }
  function union(getter) {
    var tally = {};
    S.data.forEach(function (it) { getter(it).forEach(function (v) { if (!isAny(v)) tally[v] = (tally[v] || 0) + 1; }); });
    return Object.keys(tally).sort(function (a, b) { return tally[b] - tally[a] || a.localeCompare(b); });
  }
  var VALS = null;
  function groupDefs() {
    if (!VALS) VALS = {
      good: union(function (it) { return it.g; }),
      fn: union(function (it) { return it.f; }),
      skin: union(function (it) { return it.s; })
    };
    var skinAll = VALS.skin;
    return [
      ['verdict', T.groups.verdict, ORDER.map(function (k) { return [k, VERD[k] || k]; }), function (it) { return [it.v]; }],
      ['good', T.groups.good, VALS.good.map(function (v) { return [v, v]; }), function (it) { return it.g; }],
      ['function', T.groups.function, VALS.fn.map(function (v) { return [v, v]; }), function (it) { return it.f; }],
      ['skin', T.groups.skin, skinAll.map(function (v) { return [v, v]; }), function (it) { return it.s.some(isAny) ? skinAll : it.s; }],
      ['age', T.groups.age, AGES.map(function (v) { return [v, v]; }), function (it) { return it.b; }],
      ['more', T.groups.more, MORE.map(function (m) { return [m[0], T.more[m[0]]]; }), function (it) { return MORE.filter(function (m) { return m[1](it); }).map(function (m) { return m[0]; }); }]
    ];
  }

  /* ---------- browse render ---------- */
  function renderBrowse() {
    if (!S.data) return;
    var q = S.q.trim().toLowerCase(), sel = S.sel;
    // facets, each counted against every other group
    var frag = document.createDocumentFragment();
    groupDefs().forEach(function (gd) {
      var key = gd[0], label = gd[1], vals = gd[2], getter = gd[3];
      var pool = S.data.filter(function (it) { return pass(it, sel, q, key); });
      var tally = {};
      pool.forEach(function (it) { getter(it).forEach(function (v) { tally[v] = (tally[v] || 0) + 1; }); });
      var pills = vals.map(function (pair) { return { val: pair[0], label: pair[1], count: tally[pair[0]] || 0, active: sel[key].indexOf(pair[0]) > -1 }; });
      if (key !== 'age') pills = pills.filter(function (p) { return p.count > 0 || p.active; });
      if (!pills.length) return;
      var g = h('div', 'lf-gfacet');
      g.appendChild(h('p', 'lf-gfacet__label', label));
      var row = h('div', 'lf-gfacet__pills');
      pills.forEach(function (p) {
        var b = h('button', 'lf-gpill'); b.type = 'button'; b.setAttribute('aria-pressed', p.active ? 'true' : 'false');
        b.appendChild(h('span', null, p.label)); b.appendChild(h('span', 'lf-gpill__n', num(p.count)));
        b.addEventListener('click', function () { toggle(key, p.val); });
        row.appendChild(b);
      });
      g.appendChild(row); frag.appendChild(g);
    });
    el.groups.textContent = ''; el.groups.appendChild(frag);

    // the list
    var filtered = S.data.filter(function (it) { return pass(it, sel, q, null); });
    filtered.sort(function (a, b) {
      if (SORT !== 'alphabetical') {
        var d = ORDER.indexOf(a.v) - ORDER.indexOf(b.v); if (d) return d;
        if (a.d !== b.d) return a.d === 'written' ? -1 : 1;
      }
      return a.n.localeCompare(b.n);
    });
    var shown = filtered.slice(0, CAP);
    var lf = document.createDocumentFragment();
    shown.forEach(function (it) { lf.appendChild(row(it)); });
    el.list.textContent = ''; el.list.appendChild(lf);

    el.count.textContent = anyFilter() ? fmt(T.count, { n: num(filtered.length), t: num(S.data.length) }) : fmt(T.countOnly, { n: num(S.data.length) });
    el.clear.hidden = !anyFilter();
    if (!filtered.length) setStatus(T.empty, 'empty'); else if (!S.error) setStatus('', '');
    el.capped.hidden = filtered.length <= CAP;
    el.capped.textContent = fmt(T.capped, { n: num(CAP), m: num(filtered.length) });
    syncURL();
  }

  function row(it) {
    var open = S.open === it._h;
    var art = h('article', 'lf-grow lf-grow--' + it.v + (open ? ' lf-grow--open' : ''));
    var btn = h('button', 'lf-grow__btn'); btn.type = 'button'; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var top = h('span', 'lf-grow__top'); top.appendChild(h('span', 'lf-grow__name', it.n)); top.appendChild(chip(it.v, 'md')); btn.appendChild(top);
    if (it.a.length) btn.appendChild(h('span', 'lf-grow__aka', it.a.join(' · ')));
    if (it.w) btn.appendChild(h('span', 'lf-grow__desc', it.w));
    var badges = [];
    it.g.slice(0, 3).forEach(function (g) { badges.push(badge(g.toLowerCase(), 'lime')); });
    if (it.pr === 'mod' || it.pr === 'high') badges.push(badge(T.badges.clog, 'gold'));
    if (it.c) badges.push(badge(it.c.length > 34 ? T.badges.range : it.c, 'gold'));
    if (it.st) badges.push(badge(T.badges.stacking, 'plum'));
    if (it.p.length) badges.push(badge(fmt(T.badges.inours, { n: it.p.length })));
    if (it.pc) badges.push(badge(fmt(T.badges.partof, { c: it.pc.toLowerCase() })));
    if (it.lh === 'banned') badges.push(badge(T.badges.lh));
    if (badges.length) { var br = h('span', 'lf-grow__badges'); badges.forEach(function (b) { br.appendChild(b); }); btn.appendChild(br); }
    btn.addEventListener('click', function () {
      var was = S.open === it._h; S.open = was ? null : it._h;
      var prev = el.list.querySelector('.lf-grow--open');
      if (prev && prev !== art) { prev.classList.remove('lf-grow--open'); prev.querySelector('.lf-grow__btn').setAttribute('aria-expanded', 'false'); var pd = prev.querySelector('.lf-gdetail'); if (pd) pd.remove(); }
      art.classList.toggle('lf-grow--open', !was); btn.setAttribute('aria-expanded', was ? 'false' : 'true');
      var d = art.querySelector('.lf-gdetail'); if (d) d.remove();
      if (!was) art.appendChild(detail(it));
      syncURL();
    });
    art.appendChild(btn);
    if (open) art.appendChild(detail(it));
    return art;
  }

  function poreText(risk) {
    var base = T.pore[risk]; if (!base) return '';
    return base + ' ' + T.pore.scope;
  }
  function defs(pairs) {
    var dl = h('dl', 'lf-gdefs');
    pairs.forEach(function (p) {
      if (!p[1] || !String(p[1]).trim()) return;
      var d = h('div', 'lf-gdef'); d.appendChild(h('dt', null, p[0])); d.appendChild(h('dd', null, String(p[1]).trim())); dl.appendChild(d);
    });
    return dl.children.length ? dl : null;
  }
  function callout(k, body, rule) { var c = h('div', 'lf-gcall' + (rule ? ' lf-gcall--rule' : '')); c.appendChild(h('p', 'lf-gcall__k', k)); c.appendChild(h('p', 'lf-gcall__p', body)); return c; }
  function detail(it) {
    var d = h('div', 'lf-gdetail'), D = T.defs;
    var a = defs([[D.what, it.w], [D.does, it.f.join(', ')], [D.take, it.t], [D.look, it.c], [D.part, it.pc], [D.age, it.b.join(' · ')], [D.best, it.g.join(' · ')], [D.skin, it.s.join(' · ')], [D.pore, poreText(it.pr)], [D.pairs, it.pw]]);
    if (a) d.appendChild(a);
    if (it.st) d.appendChild(callout(D.stacking, it.st));
    var lhWord = { banned: 'Banned', conditional: 'Conditional', allowed: 'Allowed' }[it.lh];
    var b = defs([[D.instead, it.ui], [D.other, lhWord ? fmt(T.otherStandard, { w: lhWord }) : ''], [D.scope, it.sn]]);
    if (b) d.appendChild(b);
    if (it.wd) d.appendChild(callout(D.disagree, it.wd, true));
    if (it.p.length) {
      var pw = h('div', 'lf-gfind');
      pw.appendChild(h('p', 'lf-gfacet__label', D.findin));
      var pr = h('div', 'lf-gprods');
      it.p.forEach(function (p) { var a2 = h('a', 'lf-gprod'); a2.href = p.u; a2.appendChild(h('span', 'lf-gprod__n', p.n)); if (p.v) a2.appendChild(h('span', 'lf-gprod__v', p.v)); pr.appendChild(a2); });
      pw.appendChild(pr); d.appendChild(pw);
    }
    var src = h('div', 'lf-gsrc'); src.appendChild(h('span', null, (it.src && it.src[0]) || T.sourceFallback));
    if (it.u) { var o = h('a', 'lf-gsrc__open', D.open + ' →'); o.href = it.u; src.appendChild(o); }
    d.appendChild(src);
    return d;
  }

  /* ---------- label checker ---------- */
  function parseLabel(text) {
    return String(text || '').replace(/\r/g, '\n').split(/[,\n;]/)
      .map(function (t) { return t.replace(/\([^)]*\)/g, ' ').replace(/[\*†‡\.]+/g, ' ').trim(); })
      .filter(function (t) { return t.length > 1; });
  }
  function matchToken(tok) {
    var items = S.data, n = norm(tok); if (!n) return null;
    for (var i = 0; i < items.length; i++) { var it = items[i], k = it._norms.indexOf(n); if (k > -1) return { it: it, as: k === 0 ? null : (it.a[k - 1] || tok) }; }
    if (n.length >= 6) {
      for (var j = 0; j < items.length; j++) {
        var it2 = items[j];
        for (var m = 0; m < it2._norms.length; m++) { var cand = it2._norms[m]; if (cand.length >= 6 && (n.indexOf(cand) > -1 || cand.indexOf(n) > -1)) return { it: it2, as: m === 0 ? it2.n : it2.a[m - 1] }; }
      }
    }
    return null;
  }
  function renderCheck() {
    var C = T.check, tokens = parseLabel(el.label.value), hits = [], seen = {};
    if (!S.data) { el.vhead.textContent = C.idle; return; }
    tokens.forEach(function (tok, i) { var m = matchToken(tok); if (!m || seen[m.it._h]) return; seen[m.it._h] = true; hits.push({ it: m.it, as: m.as, pos: i + 1 }); });
    hits.sort(function (a, b) { return (ORDER.indexOf(a.it.v) - ORDER.indexOf(b.it.v)) || a.pos - b.pos; });
    var nNever = hits.filter(function (x) { return x.it.v === 'never-allowed'; }).length;
    var nPore = hits.filter(function (x) { return x.it.pr === 'mod' || x.it.pr === 'high'; }).length;
    var nLove = hits.filter(function (x) { return POSITIVE[x.it.v]; }).length;
    var total = tokens.length, head = C.idle, sub = null, box = 'allowed';
    if (total && !hits.length) head = C.nomatch;
    else if (nNever) { head = nNever === 1 ? C.never1 : fmt(C.neverN, { n: nNever }); sub = C.neverSub; box = 'never-allowed'; }
    else if (nPore) { head = fmt(C.pore, { n: nPore, s: nPore === 1 ? 'ingredient' : 'ingredients' }); sub = C.poreSub; box = 'safe-comedogenic'; }
    else if (hits.length) { head = C.clear; sub = nLove ? (nLove === 1 ? C.love1 : fmt(C.loveN, { n: nLove })) : null; box = 'we-look-for-this'; }
    el.vbox.className = 'lf-gverdict lf-gverdict--' + box;
    el.vhead.textContent = head; el.vsub.textContent = sub || ''; el.vsub.hidden = !sub;
    var frag = document.createDocumentFragment();
    hits.forEach(function (x) {
      var r = h('div', 'lf-gcrow lf-grow--' + x.it.v + (x.pos <= 5 ? ' lf-gcrow--high' : ''));
      var top = h('div', 'lf-gcrow__top');
      var pos = h('span', 'lf-gcrow__pos'); pos.appendChild(h('span', 'lf-gcrow__num', String(x.pos))); pos.appendChild(h('span', 'lf-gcrow__of', fmt(C.of, { n: total }))); top.appendChild(pos);
      top.appendChild(h('span', 'lf-gcrow__name', x.it.n)); top.appendChild(chip(x.it.v, 'sm')); r.appendChild(top);
      if (x.it.w) r.appendChild(h('p', 'lf-gcrow__desc', x.it.w));
      if (x.as) r.appendChild(h('p', 'lf-gcrow__as', fmt(C.matched, { a: x.as })));
      frag.appendChild(r);
    });
    el.crows.textContent = ''; el.crows.appendChild(frag); el.crows.hidden = !hits.length;
    el.cempty.hidden = !(total > 0 && !hits.length);
    var un = total - hits.length;
    el.cunmatched.hidden = !(un > 0 && hits.length);
    el.cunmatched.textContent = un === 1 ? C.unmatched1 : fmt(C.unmatchedN, { n: un });
  }

  /* ---------- tabs and URL ---------- */
  function setMode(mode) {
    S.mode = mode;
    Array.prototype.forEach.call(el.tabs, function (t) { var on = t.getAttribute('data-lf-tab') === mode; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    Array.prototype.forEach.call(el.panels, function (p) { p.hidden = p.getAttribute('data-lf-panel') !== mode; });
    if (mode === 'check') load().then(renderCheck);
    syncURL();
  }
  function syncURL() {
    var p = new URLSearchParams();
    if (S.q) p.set('q', S.q);
    Object.keys(S.sel).forEach(function (k) { if (S.sel[k].length) p.set(k, S.sel[k].join(',')); });
    if (S.mode === 'check') p.set('mode', 'check');
    if (S.open) p.set('entry', S.open);
    var qs = p.toString();
    try { history.replaceState(null, '', qs ? '?' + qs : location.pathname); } catch (e) {}
  }
  function readURL() {
    var p = new URLSearchParams(location.search);
    var list = function (k) { return (p.get(k) || '').split(',').map(trim).filter(Boolean); };
    S.sel = { verdict: list('verdict'), function: list('function'), good: list('good'), skin: list('skin'), age: list('age'), more: list('more') };
    S.q = p.get('q') || ''; el.q.value = S.q;
    if (p.get('mode') === 'check') setMode('check');
    if (anyFilter() || p.get('entry')) load();
  }

  /* ---------- wiring ---------- */
  Array.prototype.forEach.call(el.tabs, function (t) {
    t.addEventListener('click', function () { setMode(t.getAttribute('data-lf-tab')); });
    t.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = t.getAttribute('data-lf-tab') === 'browse' ? 'check' : 'browse'; setMode(n); root.querySelector('[data-lf-tab="' + n + '"]').focus(); } });
  });
  el.q.addEventListener('focus', function () { load(); }, { once: true });
  el.q.addEventListener('input', debounce(function () { S.q = el.q.value; load().then(renderBrowse); }, 120));
  el.clear.addEventListener('click', function () { S.q = ''; el.q.value = ''; S.sel = { verdict: [], function: [], good: [], skin: [], age: [], more: [] }; renderBrowse(); });
  el.list.addEventListener('click', function (e) {
    // a server-rendered row was tapped before the data arrived: load, then open it in place
    if (S.data) return;
    var a = e.target.closest('a.lf-grow__btn'); if (!a) return;
    e.preventDefault(); var href = a.getAttribute('href') || ''; var hnd = href.split('/').pop();
    load().then(function () { if (S.data) { var hit = S.data.filter(function (x) { return x._h === hnd; })[0]; if (hit) { S.open = hit._h; renderBrowse(); var o = el.list.querySelector('.lf-grow--open'); if (o) o.scrollIntoView({ block: 'nearest' }); } } });
  }, { once: false });
  el.label.addEventListener('input', debounce(renderCheck, 150));
  el.labelClear.addEventListener('click', function () { el.label.value = ''; renderCheck(); });
  el.labelReset.addEventListener('click', function () { el.label.value = EXAMPLE; renderCheck(); });

  readURL();

  // idle prefetch: only when the section allows it and the connection is not metered or slow
  if (root.getAttribute('data-lf-prefetch') === 'true' && !S.data && !S.loading) {
    var c = navigator.connection || {};
    var slow = c.saveData || /(^|-)2g$/.test(c.effectiveType || '') || c.effectiveType === '3g';
    if (!slow) {
      var go = function () { setTimeout(load, 1200); };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 }); else go();
    }
  }
})();